import { reactive } from 'vue'
import SistemaSrv from '@/services/SistemaSrv.js'
import WhatsappSrv from '@/services/WhatsappSrv.js'
import { escucharWhatsappGlobal } from '@/broadcasting/main.js'
import { notificarMensajeWhatsapp, solicitarPermisoNotificaciones } from '@/services/WhatsappNotificaciones.js'

// Estado global (reactivo) del ajuste "whatsapp": 1/true = activo, 0/false = desactivado.
// Lo usan el menú lateral y el guardián de rutas para ocultar/bloquear el módulo.
export const estadoWhatsapp = reactive({
  activo: false,
  cargado: false,
  mensajesNuevos: 0
})

const TTL_MS = 5000
const TTL_MENSAJES_MS = 2000
let promesa = null
let ultimaConsulta = 0
let promesaMensajesNuevos = null
let ultimaConsultaMensajes = 0
let debounceWsTimer = null
let listenerGlobalRegistrado = false

export function cargarMensajesNuevosWhatsapp(forzar = false) {
  if (promesaMensajesNuevos) return promesaMensajesNuevos
  const transcurrido = Date.now() - ultimaConsultaMensajes
  if (ultimaConsultaMensajes > 0 && transcurrido < (forzar ? 400 : TTL_MENSAJES_MS)) {
    return Promise.resolve(estadoWhatsapp.mensajesNuevos)
  }

  ultimaConsultaMensajes = Date.now()
  promesaMensajesNuevos = WhatsappSrv.mensajesNuevos()
    .then(response => {
      const res = response && response.data !== undefined ? response.data : response
      const total = typeof res === 'number' ? res : (res?.total ?? res?.mensajes_nuevos ?? 0)
      estadoWhatsapp.mensajesNuevos = Math.min(Math.max(Number(total) || 0, 0), 99)
      return estadoWhatsapp.mensajesNuevos
    })
    .catch(() => {
      ultimaConsultaMensajes = 0
      return estadoWhatsapp.mensajesNuevos
    })
    .finally(() => {
      promesaMensajesNuevos = null
    })

  return promesaMensajesNuevos
}

function onConversacionesWhatsappGlobal(data) {
  if (!estadoWhatsapp.activo) return

  // Disparar la notificación del sistema si corresponde
  if (data) {
    notificarMensajeWhatsapp(data)
  }

  if (debounceWsTimer) clearTimeout(debounceWsTimer)
  debounceWsTimer = setTimeout(() => {
    debounceWsTimer = null
    cargarMensajesNuevosWhatsapp(true)
  }, 150)
}

export function cargarEstadoWhatsapp(forzar = false) {
  if (!forzar && promesa && Date.now() - ultimaConsulta < TTL_MS) return promesa

  ultimaConsulta = Date.now()
  promesa = SistemaSrv.ajustes(['whatsapp'])
    .then(response => {
      const valor = response && response.data && response.data.whatsapp !== undefined
        ? response.data.whatsapp
        : (response ? response.whatsapp : undefined)

      estadoWhatsapp.activo = ['1', 1, 'true', true].includes(valor)
      estadoWhatsapp.cargado = true

      if (estadoWhatsapp.activo) {
        cargarMensajesNuevosWhatsapp()
        solicitarPermisoNotificaciones().catch(() => {})
        if (!listenerGlobalRegistrado) {
          listenerGlobalRegistrado = true
          escucharWhatsappGlobal(onConversacionesWhatsappGlobal)
        }
      } else {
        estadoWhatsapp.mensajesNuevos = 0
      }

      return estadoWhatsapp.activo
    })
    .catch(() => {
      // Si no se puede consultar, se conserva el último estado conocido (por defecto: desactivado)
      promesa = null
      return estadoWhatsapp.activo
    })

  return promesa
}

